module.exports = __webpack_public_path__ + "img/place.f91fe62f.svg";